export const GLOBAL_VARS = {
  ENVIRONMENT: 'DEVELOPMENT',
  API: 'https://api.rutas.civischile.cl/api',
};
